export default function MenuButton({ Element, onClick, sx }) {
  return (
    <Element
      onClick={onClick}
      style={{ padding: 5, fontSize: 40, cursor: "pointer" }}
      sx={sx}
    />
  );
}
